import { cn } from "@/utils";

/**
 * Completed step icon (green checkmark)
 */
export const CompletedIcon: React.FC<{ step: number; className?: string }> = ({ step, className }) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={cn('pointer-events-none', className)}
    data-testid={`completed-step-icon-${step}`}
  >
    <circle cx="10" cy="10" r="10" fill="var(--color-accent-green-300)" />
    <path
      d="M6 10l2.5 2.5L14 7"
      stroke="white"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

/**
 * Active step icon (red circle with number)
 */
export const ActiveIcon: React.FC<{ step: number; className?: string }> = ({ step, className }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    className={cn('pointer-events-none', className)}
    data-testid={`active-step-icon-${step}`}
  >
    <circle cx="10" cy="10" r="8" stroke="var(--color-brand-primary)" strokeWidth="2" />
    <circle cx="10" cy="10" r="6" fill="var(--color-brand-primary)" />
  </svg>
);

/**
 * Upcoming step icon (light pink circle)
 */
export const UpcomingIcon: React.FC<{ step: number; className?: string }> = ({ step, className }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    className={cn('pointer-events-none', className)}
    data-testid={`upcoming-step-icon-${step}`}
  >
    <circle cx="10.125" cy="10.125" r="8.125" fill="var(--color-accent-surface-red)" />
  </svg>
);

/**
 * Arrow separator icon
 */
export const ArrowSeparator: React.FC<{ className?: string; index?: number }> = ({ className, index }) => (
  <div
    data-testid={`arrow-separator-${index}`}
    className={cn(
      'pointer-events-none h-[1px] w-[24px] border-t border-neutral-gray-400',
      className,
    )}
  />
);